import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Dashboard from "../../layouts/Dashboard";
import { Card, Modal, Input, Tag, Table, Select, message } from "antd";
import axios from "../../services/axios";
import url from "../../services/url";
import locations from "../../utils/api/locations";
import Axios from "axios";
import moment from "moment";
import ReactLoading from "react-loading";
import BASE from "../../config";
import LoadingArea from "../../components/LoadingArea";
import { useLocation } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import useUserId from "../../hooks/useUserId";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const { Option } = Select;

function TalentRequisitionAssign() {
  const [loader, setLoader] = useState(false);
  const [editable, setEditable] = useState(false);
  const [upDateable, setUpdateable] = useState(false);
  // const [userLoading, setUserLoading] = useState(false);
  const [freez, setFreez] = useState(false);
  // const [current, setCurrent] = useState(1);
  const [trfList, setTrfList] = useState([]);
  const [trfDetails, setTrfDetails] = useState({});
  // const [pending, setPending] = useState(0);
  // const [inprogress, setInProgress] = useState(0);
  const [userList, setUserList] = useState([]);
  // const [transferUserList, setTransferUserList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [distributedTrf, setDistributedTrf] = useState([]);
  const [preferredLocation, setPreferredLocation] = useState([]);
  const [data, setData] = useState([]);
  // const [transferCandidate, setTransferCandidate] = useState([]);
  // const [assignedUsers, setAssignedUsers] = useState([]);
  const [filterData, setFilterData] = useState({
    dept: "",
    location: ""
  });

  const userRole = useRole();
  const [canAllocate, setCanAllocate] = useState(false);

  const checkPermissions = async () => {
    try {
      const allowed = await checkPermission(
        userRole,
        "assign_trf_module",
        "allocate_trf"
      );
      setCanAllocate(allowed);
    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const location = useLocation();
  const api = useAxios()
  const userId = useUserId()
  const searchParams = new URLSearchParams(location.search);
  // const idTrf = searchParams.get("id");

  // const [transferModal, setTransferModal] = useState(false);
  // const [transferInitialData, setTransferInitialData] = useState({});

  const [totalVac, setTotalVac] = useState(0);
  const [assignUnassign, setAssignUnassign] = useState('');

  // const onChange = (page) => {
  //   setCurrent(page);
  // };

  const getDepartmentList = async () => {
    try {
      const result = await api.get(`/trfDepartment`, { tokenType: 'user' })
      setDepartmentList(result.data.trfDepartment);
    } catch (err) {
      console.log(err)
      setDepartmentList([]);
    }
  };

  const handleChange = (e, _id) => {
    e.persist();
    userList.forEach((user) => {
      if (user._id === _id) {
        user.value = e.target?.value;
      }
    });
    setData((prevData) => {
      let tableData = [...prevData];
      let obj = {
        userId: _id,
        vacancyCount: Number(e.target?.value)
      };

      if (e.target.value === "") {
        let flag = false;
        userList.forEach((doc) => {
          if (doc._id === _id) {
            if (doc.inprogress > 0) {
              flag = true;
              tableData.forEach((val) => {
                if (val.userId === _id) {
                  val.vacancyCount = 0;
                  // val.vacancyCount = 1
                }
              });
              // doc.value = 1;
              // message.warning("Before assigning 0, clear transfer first.", 2);
            }
          }
        });

        if (!flag) {
          tableData = tableData.filter((d) => d.userId !== _id);
        } else {
          setUserList([...userList]);
        }
      } else {
        const index = tableData.findIndex((d) => d.userId === _id);
        if (index !== -1) {
          tableData[index] = obj;
        } else {
          tableData.push(obj);
        }
      }

      let total = tableData.reduce(
        (accumulator, currentValue) => accumulator + currentValue.vacancyCount,
        0
      );

      setTotalVac(total);

      let i = tableData.map((e) => e.userId);
      if (trfDetails.numberOfVacancies + (trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0) <= total) {
        if (e.target.value !== "") {
          i.push(_id);
          userList.forEach((ele) => {
            if (i.includes(ele._id)) {
              if (
                tableData.filter((doc) => doc.userId === ele._id)[0]
                  .vacancyCount === 0
              ) {
                ele.editable = true;
              } else {
                ele.editable = false;
              }
            } else {
              ele.editable = true;
            }
          });
          setUserList([...userList]);
          if (trfDetails.numberOfVacancies + ((trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0) ? (trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0) : 0) < total) {
            message.warning("Limit Exceeded", 2);
            return [...tableData];
          }
        } else {
          // userList.forEach((ele) => {
          //   if (i.includes(ele._id)) {
          //     if(tableData.filter(doc => doc.userId === ele._id)[0].vacancyCount === 0){
          //       ele.editable = true;
          //     }else{
          //       ele.editable = false;
          //     }
          //   } else {
          //     ele.editable = true;
          //   }
          // });
          userList.forEach((ele) => {
            ele.editable = false;
          });
          setUserList([...userList]);
        }
      } else {
        userList.forEach((ele) => {
          ele.editable = false;
        });
        setUserList([...userList]);
      }

      return [...tableData];
    });
  };

  const getUserList = async () => {
    Axios.get(url("user"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }
    })
      .then((result) => {
        let data = [];
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].IsUserActive) {
            data.push({
              _id: result.data[i]._id,
              email: result.data[i].email,
              name: result.data[i].name,
              role: result.data[i].role,
              info: result.data[i],
              value: -1,
            });
          }
        }
        setUserList(data);
      })
      .catch(console.error);
  };

  const getDistributedTrf = async () => {
    try {
      const res = await api.get(`/trfBasedUserMapping/distinctMapping/${userId}/trfList`, { tokenType: 'user' })
      const distinctData = res.data.filter((obj, index, self) =>
        index === self.findIndex(o =>
          o.trfId === obj.trfId && o.assignBy === obj.assignBy
        )
      );
      setDistributedTrf(distinctData);
    } catch (err) {
      console.log(err)
      setDistributedTrf([]);
    }
  };

  const mapData = async (data_, selectedTrf) => {
    // setAssignedUsers([...data_.map((ele) => ele.userId._id)]);
    let data1 = [];
    let total = 0;
    for (let i = 0; i < userList.length; i++) {
      let find = false;
      let d = {};
      for (let j = 0; j < data_.length; j++) {
        if (userList[i]._id === data_[j].userId._id) {
          find = true;
          d = { ...data_[j] };
          break;
        }
      }
      if (find) {
        data1.push({
          _id: userList[i]._id,
          email: userList[i].email,
          name: userList[i].name,
          role: userList[i].role,
          alloted: d.numberOfVacancies,
          value: d.numberOfVacancies,
          editable: false
        });
        setData((prev) => [
          ...prev,
          {
            userId: userList[i]._id,
            vacancyCount: Number(d.numberOfVacancies)
          }
        ]);
        total = total + d.numberOfVacancies;

      } else {
        data1.push({
          _id: userList[i]._id,
          email: userList[i].email,
          name: userList[i].name,
          role: userList[i].role,
          alloted: -1,
          value: -1,
          editable: true
        });
      }
    }

    // If the already-assigned total is less than the vacancy limit, unlock
    // unassigned users immediately so they can absorb the remaining vacancies
    // without the user needing to touch an existing field first.
    const trf = selectedTrf || trfDetails;
    const limit = (trf?.numberOfVacancies || 0) + (trf?.bufferVacancyCount || 0);
    if (total < limit) {
      data1.forEach((user) => {
        if (user.alloted === -1) {
          user.editable = false; // false = input enabled
        }
      });
    }

    data1.sort(function (a, b) {
      return b.alloted - a.alloted;
    });
    setUserList((prev => data1));
    setTotalVac(total);
    setLoader(false);
  };

  useEffect(() => {
    getDepartmentList();
    locations().then((res) => {
      setPreferredLocation(res);
    });
    getDistributedTrf();
  }, []);

  useEffect(() => {
    getUserList();
  }, []);


  // not in use

  // const onTranferHandler = async (e, rec) => {
  //   setTransferInitialData(rec);
  //   const config = {
  //     url: `${BASE.api}/candidate/InterviewerId/${rec._id}/trfId/${trfDetails._id}`,
  //     method: "get",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${localStorage.getItem("user.token")}`
  //     }
  //   };  //   try {
  //     setUserLoading(true);
  //     const result = await axios(config);
  //     const array = result.data;
  //     if (Array.isArray(array)) {
  //       let data = [];
  //       for (let i = 0; i < array.length; i++) {
  //         data.push({
  //           name: array[i].name,
  //           email: array[i].email,
  //           phone: array[i].mobileNo,
  //           clicked_id: rec._id,
  //           _id: array[i]._id,
  //           disableSelect : true,
  //           uncheck: true,
  //           selected : ""
  //         });
  //       }
  //       setTransferUserList(data);
  //     } else {
  //       setTransferUserList([]);
  //     }
  //     setUserLoading(false);
  //     setTransferModal(true);
  //   } catch (err) {
  //     console.log(err);
  //     setUserLoading(false);
  //   }
  // };

  const getTrfData = async () => {
    setLoader(true)
    try {
      const res = await api.get(`trf/trfForAssignment?Department=${filterData?.dept}&Location=${filterData?.location}&isTRFAssigned=${assignUnassign}&trfStatus=${true}&isTRFAssignable=${true}`, { tokenType: 'user' })
      setTrfList(res.data);
      setLoader(false)
      setTrfDetails({})
    } catch (err) {
      console.log(err)
      setLoader(false)
    }
  };

  useEffect(() => {
    getTrfData();
  }, [filterData, assignUnassign]);

  // const selectUser = (e, record) => {
  //   if (e.target.checked) {
  //     setData((prev) => [...prev, record._id]);
  //     if(upDateable){
  //       userList.forEach(user => {
  //         if(user._id === record._id){
  //           record.check = true
  //         }
  //       })
  //     }
  //   } else {
  //     setData((prev) => [...prev.filter((_id) => _id !== record._id)]);
  //     if(upDateable){
  //       userList.forEach(user => {
  //         if(user._id === record._id){
  //           record.check = false
  //         }
  //       })
  //     }
  //   }   

  //   setUserList([...userList])
  // };

  const columns = [
    {
      // title: "Select Recruiter  ",
      title: !upDateable ? "Assign Vacancy" : "Update Vacancy",
      dataIndex: "alot_vacancy",
      key: "alot_vacancy",
      fixed: "left",
      align: "center",
      render: (val, record) => {
        return (
          <>
            {/* <input  
              onChange={(e) => selectUser(e,record)} 
              checked={record.check}
              disabled={
                JSON.stringify(trfDetails) === "{}" ||
                editable ||
                freez
              }
              type="checkbox"
            /> */}
            <input
              type="number"
              className="form-control"
              min={0}
              value={
                record.value !== undefined
                  ? record.value !== -1
                    ? record.value
                    : ""
                  : ""
              }
              disabled={
                JSON.stringify(trfDetails) === "{}" ||
                record.editable ||
                editable ||
                freez
              }
              placeholder="Enter vacancy"
              name="vacancy"
              onChange={(e) => handleChange(e, record._id)}
            />
            {/* {upDateable && (
              <div className="row">
                <div className="col-3">
                  <strong style={{ color: "#000" }}>
                    Assigned : {record.alloted === -1 ? 0 : record.alloted}
                  </strong>
                </div>
                <div className="col-3">
                  <strong style={{ color: "#fd7e14" }}>
                    Pending :{" "}
                    {(record.alloted === -1 ? 0 : record.alloted) -
                      record.completed}
                  </strong>
                </div>
                <div className="col-3">
                  <strong style={{ color: "#fd7e14" }}>
                    In Progress : {record.inprogress ? record.inprogress : 0}
                  </strong>
                </div>
                <div className="col-3">
                  <strong style={{ color: "green" }}>
                    Joined : {record.completed}
                  </strong>
                </div>
              </div>
            )} */}
          </>
        );
      }
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name > b.name,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email > b.email,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.email.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      sorter: (a, b) => a.role > b.role,
      render: (text) => {
        const isInterviewer =
          text?.toLowerCase() === "interviewer" ||
          text?.toLowerCase() === "interview";
        return isInterviewer ? "DH_Recruiters" : text;
      },
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        const isInterviewer =
          record.role?.toLowerCase() === "interviewer" ||
          record.role?.toLowerCase() === "interview";
        const displayRole = isInterviewer ? "DH_Recruiters" : record.role;
        return (
          (record.role && record.role.toLowerCase().includes(value.toLowerCase())) ||
          (displayRole && displayRole.toLowerCase().includes(value.toLowerCase()))
        );
      }
    },

    // upDateable
    //   ? {
    //       title: "Transfer",
    //       dataIndex: "transfer",
    //       key: "transfer",
    //       fixed: "right",
    //       align: "center",
    //       render: (val, record) => {
    //         return record.inprogress !== 0 ? (
    //           <button
    //             className={`btn-sm ${"btn-primary"}`}
    //             type="submit"
    //             style={{ width: "100%" }}
    //             onClick={(e) => {
    //               onTranferHandler(e, record);
    //             }}>
    //             Transfer
    //           </button>
    //         ) : (
    //           <></>
    //         );
    //       }
    //     }
    //   : null
  ];

  // const transferCandidateCheckbox = (e,rec) => {
  //   let enableArray = transferCandidate.map(en => en.candidateId)
  //   let obj = {
  //     userId : "",
  //     candidateId : rec._id
  //   }
  //   if(e.target.checked){
  //     enableArray.push(rec._id)
  //     setTransferCandidate([...transferCandidate,obj])
  //     transferUserList.forEach(user => {
  //       if(enableArray.includes(user._id)){
  //         user.disableSelect = false
  //         user.uncheck = false
  //       }else{
  //         user.disableSelect = true
  //         user.uncheck = true
  //         user.selected = ""
  //       }
  //     })
  //   }else{
  //     enableArray = enableArray.filter(f => f !== rec._id)
  //     setTransferCandidate([...transferCandidate.filter(data => data.candidateId !== rec._id)])
  //     transferUserList.forEach(user => {
  //       if(enableArray.includes(user._id)){
  //         user.disableSelect = false
  //         user.uncheck = false
  //       }else{
  //         user.disableSelect = true
  //         user.uncheck = true
  //         user.selected = ""
  //       }
  //     })
  //   }
  // }

  // const transferCandidateSelect = (e,rec) => {
  //   let enableArray = transferCandidate.map(en => en.candidateId)
  //   if(e.target.value !== ""){
  //     transferCandidate.forEach(val => {
  //       if(val.candidateId === rec._id){
  //         val.userId = e.target.value
  //       }
  //     })
  //     setTransferCandidate([...transferCandidate])
  //     transferUserList.forEach(user => {
  //       if(enableArray.includes(user._id)){
  //         if(user._id === rec._id){
  //           user.selected = e.target.value
  //         }
  //         user.disableSelect = false
  //         user.uncheck = false
  //       }else{
  //         user.disableSelect = true
  //         user.uncheck = true
  //         user.selected = ""
  //       }
  //     })
  //   }
  // }

  // const transferColumns = [
  //   {
  //     title: "Select",
  //     dataIndex: "user",
  //     key: "user",
  //     fixed: "right",
  //     align: "center",
  //     render: (val, record) => {
  //       return <input checked={!record.uncheck} onChange={(e) => transferCandidateCheckbox(e,record)} type="checkbox" />;
  //     }
  //   },
  //   {
  //     title: "Name",
  //     dataIndex: "name",
  //     key: "name",
  //     sorter: (a, b) => a.name > b.name,
  //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
  //       return (
  //         <>
  //           <Input
  //             autoFocus
  //             placeholder="Type text here"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}></Input>
  //         </>
  //       );
  //     },
  //     filterIcon: () => {
  //       return <SearchOutlined />;
  //     },
  //     onFilter: (value, record) => {
  //       return record.name.toLowerCase().includes(value.toLowerCase());
  //     }
  //   },
  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //     key: "email",
  //     sorter: (a, b) => a.email > b.email,
  //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
  //       return (
  //         <>
  //           <Input
  //             autoFocus
  //             placeholder="Type text here"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}></Input>
  //         </>
  //       );
  //     },
  //     filterIcon: () => {
  //       return <SearchOutlined />;
  //     },
  //     onFilter: (value, record) => {
  //       return record.email.toLowerCase().includes(value.toLowerCase());
  //     }
  //   },
  //   {
  //     title: "Mobile No.",
  //     dataIndex: "phone",
  //     key: "phone",
  //     sorter: (a, b) => a.role > b.role,
  //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
  //       return (
  //         <>
  //           <Input
  //             autoFocus
  //             placeholder="Type text here"
  //             value={selectedKeys[0]}
  //             onChange={(e) => {
  //               setSelectedKeys(e.target.value ? [e.target.value] : []);
  //               confirm({ closeDropdown: false });
  //             }}
  //             onBlur={() => {
  //               confirm();
  //             }}></Input>
  //         </>
  //       );
  //     },
  //     filterIcon: () => {
  //       return <SearchOutlined />;
  //     },
  //     onFilter: (value, record) => {
  //       return record.role.toLowerCase().includes(value.toLowerCase());
  //     }
  //   },
  //   {
  //     title: "Recruiter List",
  //     dataIndex: "user",
  //     key: "user",
  //     fixed: "right",
  //     align: "center",
  //     render: (val, record) => {
  //       return (
  //         <select value={record.selected} disabled={record.disableSelect} onChange={(e) => transferCandidateSelect(e,record)} className="form-control">
  //           <option value="">Select Recruiter</option>
  //           {userList.map((user) => {
  //             if(assignedUsers?.includes(user._id)){
  //               return (
  //                 user._id !== record.clicked_id &&
  //                 user.role === "interviewer" && (
  //                   <option value={user._id}>{user.name}</option>
  //                 )
  //               );
  //             }
  //           })}
  //         </select>
  //       );
  //     }
  //   }
  // ];

  const submitData = async (e) => {
    if (!trfDetails?._id) {
      message.warning("Please Select Trf.", 2);
      return;
    }
    if (totalVac !== trfDetails?.numberOfVacancies + ((trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0) ? (trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0) : 0)) {
      message.warning("Please assign the vacancy correctly.", 2);
      return;
    }
    try {
      setLoader(true);
      const result = await api.post(`/trfBasedUserMapping`, {
        trfId: trfDetails._id,
        assignBy: userId,
        userList: data
      }, { tokenType: 'user' });
      setLoader(false);
      setData([]);
      setTrfDetails({});
      window.location.reload();
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const onEditHandler = async (_id, selectedTrf) => {
    try {
      setLoader(true);
      const result = await api.get(`/trfBasedUserMapping/${_id}`, { tokenType: 'user' });
      setUpdateable(true);
      setEditable(false);
      mapData(result.data.trfList, selectedTrf);
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const onUpdateHandler = async (e) => {

    if (totalVac !== trfDetails?.numberOfVacancies + (trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0)) {
      message.warning("Please assign all vacancies to users.", 2);
      return;
    }
    // let completed = [];
    // const validData = data.map((d) => d.userId);
    // let arra = [...data];

    // userList.map((data) => {
    //   if (!validData.includes(data._id)) {
    //     if (data.completed > 0) {
    //       completed.push({
    //         userId: data._id,
    //         vacancyCount: data.completed 
    //       });  
    //     }
    //   }
    // });

    // arra.forEach((data) => {
    //   userList.map((find) => {
    //     if (data.userId === find._id) {
    //       data.vacancyCount = data.vacancyCount + find.completed;
    //     }  
    //   });
    // });

    try {
      setLoader(true);
      const result = await api.put(`/trfBasedUserMapping`, {
        trfId: trfDetails._id,
        assignBy: userId,
        userList: data
      }, { tokenType: 'user' });
      setLoader(false);
      setData([]);
      setTrfDetails({});
      setUpdateable(false);
      setEditable(false);
      window.location.reload();
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  // const onTransferCandidate = async () => {
  //   const validate = transferCandidate.every(validate => validate.userId !== "")
  //   if(transferCandidate.length === 0) {
  //     message.warning("Select atleast one candiadte.", 2);
  //     return
  //   }
  //   if(!validate) {
  //     message.warning("Please select recruiter", 2);
  //     return
  //   }
  //   const config = {
  //     url: `${BASE.api}/trfBasedUserMapping/Assignto`,
  //     method: "patch",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${localStorage.getItem("user.token")}`
  //     },
  //     data: {
  //       trfId: trfDetails._id,
  //       assignBy: localStorage.getItem("user.id"),
  //       userId: transferInitialData._id,
  //       assignUserIdList: transferCandidate
  //     }
  //   };

  //   try {
  //     setLoader(true);
  //     const result = await axios(config);
  //     onEditHandler()
  //     setTransferCandidate([])
  //     setTransferModal(false)
  //     setLoader(false);
  //   } catch (err) {
  //     console.log(err);
  //     setLoader(false);
  //   }
  // }

  return (
    <>
      <Dashboard title="Assign TRF">
        {loader && (
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        )}
        <></>
        <div className="row">
          <div className="col-12">
            <Card title="" className="border mt-3">
              {/* <div className="row d-flex"> */}
              {/* <div className="col-md-8"> */}
              <div className="row">
                <div className="col-md-2">
                  <label htmlFor="candidate photo">Select Department</label>
                  <Select
                    showSearch
                    style={{ width: "100%", height: "37px" }}
                    placeholder="Select Department"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option?.children
                          ?.toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    onChange={(value) =>
                      setFilterData({
                        ...filterData,
                        dept: value
                      })
                    }>
                    <Option value={""}>All</Option>
                    {departmentList?.map((dept) => (
                      <Option value={dept?.department}>
                        {dept?.department}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="candidate photo">Select Location</label>
                  <Select
                    showSearch
                    style={{ width: "100%", height: "37px" }}
                    placeholder="Select Location"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option?.children
                          ?.toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    onChange={(value) =>
                      setFilterData({
                        ...filterData,
                        location: value
                      })
                    }>
                    <Option value={""}>All</Option>
                    {preferredLocation?.map((loc) => (
                      <Option value={loc?.locationName}>
                        {loc?.locationName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="candidate photo">Select Trf Type</label>
                  <Select
                    showSearch
                    style={{ width: "100%", height: "37px" }}
                    placeholder="Select Trf Type  "
                    optionFilterProp="children"
                    value={assignUnassign}
                    filterOption={(input, option) => {
                      return (
                        option?.children
                          ?.toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    onChange={(value) =>
                      setAssignUnassign(value)
                    }>
                    <Option value={""}>All</Option>
                    <Option value={"Assigned"}>Assigned</Option>
                    <Option value={"UnAssigned"}>UnAssigned</Option>
                  </Select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="candidate photo">
                    Select TRF
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    showSearch
                    style={{ width: "100%", height: "37px" }}
                    placeholder="Select Trf"
                    value={trfDetails?._id}
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option?.children
                          ?.toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.value
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                    onChange={(value) => {
                      const selectedTrfObj = trfList?.filter((trf) => trf._id === value)[0];
                      setTrfDetails(selectedTrfObj);
                      let flag = false;
                      let freez = false;
                      for (let obj of distributedTrf) {
                        if (
                          obj.trfId === value &&
                          obj.assignBy === userId
                        ) {
                          flag = true;
                        }

                        if (obj.trfId === value) {
                          freez = true;
                        }
                      }
                      if (flag) {
                        // setEditable(true);
                        onEditHandler(value, selectedTrfObj)
                        setUpdateable(false);
                      } else {
                        // setEditable(false);
                        setUpdateable(false);
                      }

                      if (!flag && freez) {
                        setFreez(true);
                        onEditHandler(value, selectedTrfObj)
                        // setEditable(true);
                      } else {
                        setFreez(false);
                      }
                      // userList.forEach((list) => {
                      //   list.check = false;
                      // });
                      // setUserList([...userList]);
                      setData([]);
                      // setInProgress(0);
                    }}>
                    {/* <Option value="">All</Option> */}
                    {trfList?.map(
                      (option) =>
                        option?.Status && (
                          <Option value={option._id}>{`(${option?.candidateType})-${option?.title}-${option?.department
                            }-${option?.location}-${option?.processName}-${moment(
                              option?.tat
                            )
                              .utc()
                              .format("YYYY-MM-DD")}${option?.workModal ? `-${option.workModal}` : ""
                            }`}</Option>
                        )
                    )}
                  </Select>
                </div>
                {/* </div> */}
                {/* <div className="row mt-2 align-items-end"> */}
                <div className="col-md-2">
                  {!editable && !upDateable && (
                    <div className="mt-4 ">
                      {canAllocate && (
                        <button
                          className={`btn ${!editable ? "btn-primary" : "btn-secondary"
                            }`}
                          type="submit"
                          disabled={editable}
                          style={{ width: "100%" }}
                          onClick={submitData}>
                          Save
                        </button>
                      )}
                    </div>
                  )}
                  {editable && (
                    <div className="mt-4">
                      {canAllocate && (
                        <button
                          className={`btn ${"btn-primary"}`}
                          type="submit"
                          style={{ width: "100%" }}
                          onClick={onEditHandler}>
                          Edit
                        </button>
                      )}
                    </div>
                  )}
                  {(upDateable && !freez) && (
                    <div className="mt-4">
                      {canAllocate && (
                        <button
                          className={`btn ${"btn-primary"}`}
                          type="submit"
                          style={{ width: "100%" }}
                          onClick={onUpdateHandler}>
                          Update
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {/* </div> */}
              <div className="row mt-4">
                <div className={`col-md-4`}>
                  <div className="vacancy shadow-sm border-radius">
                    <h5>Actual + Buffer</h5>
                    <span>
                      <Tag color="#f8a61b">
                        <h6 style={{ marginBottom: 0, padding: '2px' }}>{`${trfDetails?.numberOfVacancies ? trfDetails?.numberOfVacancies : 0} + ${trfDetails?.bufferVacancyCount ? + trfDetails?.bufferVacancyCount : 0}`}</h6>
                      </Tag>
                    </span>
                  </div>
                </div>
                <div className={`col-md-4`}>
                  <div className="vacancy shadow-sm border-radius">
                    <h5>Total Vacancy</h5>
                    <span>
                      <Tag color="#87d068">
                        <h6 style={{ marginBottom: 0, padding: '2px' }}>{trfDetails?.numberOfVacancies
                          ? trfDetails?.numberOfVacancies + (trfDetails?.bufferVacancyCount ? trfDetails?.bufferVacancyCount : 0)
                          : 0}</h6>
                      </Tag>
                    </span>
                  </div>
                </div>
                {/* <div className={`col-md-${upDateable ? "3" : "4"}`}>
                  <div className="vacancy shadow-sm border-radius">
                    <h5>Pending Vacancy</h5>
                    <span>
                      <Tag color="#fd7e14">{pending}</Tag>
                    </span>
                  </div>
                </div>
                {upDateable && (  
                  <div className="col-md-3">
                    <div className="vacancy shadow-sm border-radius">
                      <h5>In Progress</h5>
                      <span>
                        <Tag color="#fd7e14">{inprogress}</Tag>
                      </span>
                    </div>
                  </div>
                )} */}
                <div className={`col-md-4`}>
                  <div className="vacancy shadow-sm border-radius">
                    <h5>Joined Vacancy</h5>
                    <span>
                      <Tag color="#f50">
                        <h6 style={{ marginBottom: 0, padding: '2px' }}>{trfDetails?.joinedCandidate
                          ? trfDetails?.joinedCandidate
                          : 0}</h6>
                      </Tag>
                    </span>
                  </div>
                </div>
                {/* <div className={`col-md-4`}>
                  <div className="vacancy shadow-sm border-radius">
                    <div className="d-flex gap-2">
                      <input type="radio" id='Assigned' checked={assignUnassign === 'Assigned'} name="isTRFAssigned" value={'Assigned'} onChange={(e) => setAssignUnassign(e.target.value)} />
                      <label htmlFor="Assigned">Assigned</label>
                    </div>
                    <div className="d-flex gap-2">
                      <input type="radio" id='UnAssigned' checked={assignUnassign === 'UnAssigned'}  name="isTRFAssigned" value={'UnAssigned'} onChange={(e) => setAssignUnassign(e.target.value)} />
                      <label htmlFor="UnAssigned">UnAssigned</label>
                    </div>
                  </div>
                </div> */}
              </div>
              {/* </div> */}
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card title="Recruiters List" className="border mt-3">
              <div style={{ width: "100%" }}>
                <Table
                  columns={columns.filter((col) => col !== null)}
                  dataSource={userList}
                  pagination={{
                    // total:count,
                    pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                    showSizeChanger: false
                  }}
                  scroll={{ x: true }}
                  style={{ whiteSpace: "pre" }}
                  exportFileName="details"
                />
              </div>
            </Card>
          </div>
        </div>
      </Dashboard>
      {/*<Modal
        title="Transfer"
        centered
        open={transferModal}
        onOk={() => {
          setTransferModal(false)
          setTransferCandidate([])
        }}
        onCancel={() => {
          setTransferModal(false)
          setTransferCandidate([])
        }}
        width={1000}
        footer={
          <div className="d-flex gap-1 align-items-center justify-content-center">
            <button onClick={onTransferCandidate} className="btn btn-primary">Update</button>
          </div>
        }>
        <Card className="border bg-white mb-4">
          <div className="row">
            <div className={`col-md-${upDateable ? '3' : '4'}`}>
              <div className="vacancy shadow-sm border-radius">
                <h5>Total</h5>
                <span>
                  <Tag color="#87d068">
                    {transferInitialData?.alloted !== -1
                      ? transferInitialData?.alloted
                      : 0}
                  </Tag>
                </span>
              </div>
            </div>
            <div className={`col-md-${upDateable ? '3' : '4'}`}>
              <div className="vacancy shadow-sm border-radius">
                <h5>Pending</h5>
                <span>
                  <Tag color="#fd7e14">
                    {(transferInitialData?.alloted !== -1
                      ? transferInitialData?.alloted
                      : 0) - transferInitialData?.completed} 
                  </Tag>
                </span>
              </div>
            </div>
            {
                  upDateable &&
                  <div className="col-md-3">
                    <div className="vacancy shadow-sm border-radius">
                      <h5>In Progress</h5>
                      <span>  
                        <Tag color="#fd7e14">{transferInitialData?.inprogress}</Tag>
                      </span>
                    </div>
                  </div>
                }
            <div className={`col-md-${upDateable ? '3' : '4'}`}>
              <div className="vacancy shadow-sm border-radius">
                <h5>Joined</h5>
                <span>
                  <Tag color="#f50">
                    {transferInitialData?.completed
                      ? transferInitialData?.completed
                      : 0}
                  </Tag>
                </span>
              </div>
            </div>
          </div>
        </Card>
        <Card className="border mt-3">
          <LoadingArea isLoading={userLoading}>
            <div style={{ width: "100%" }}>
              <Table
                columns={transferColumns}
                dataSource={transferUserList}
                pagination={{
                  // total:count,
                  pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                  showSizeChanger: false,
                }}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
                exportFileName="details"
              />
            </div>
          </LoadingArea>
        </Card>
              </Modal> */}
    </>
  );
}

export default TalentRequisitionAssign;
